import React from 'react';
import { useCafeteriaSelection } from '../../../context/CafeteriaSelectionContext';
import PlaceBusinessHoursMatrix from '../../../components/PlaceBusinessHoursMatrix';
import LoadingSpinner from '../../../components/ui/LoadingSpinner';

const BusinessHoursPage: React.FC = () => {
  const { currentCafeteria, isLoading, error } = useCafeteriaSelection();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-6">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-red-800">
              Erro ao carregar cafeteria
            </h3>
            <div className="mt-2 text-sm text-red-700">
              <p>{error}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!currentCafeteria) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-yellow-800">
              Nenhuma cafeteria selecionada
            </h3>
            <div className="mt-2 text-sm text-yellow-700">
              <p>Selecione uma cafeteria no menu lateral para gerenciar os horários de funcionamento.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Horários de Funcionamento</h1>
            <p className="mt-1 text-sm text-gray-600">
              Configure os horários de funcionamento para <span className="font-medium text-gray-900">{currentCafeteria.name}</span>
            </p>
          </div>
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-green-400 rounded-full"></div>
            <span className="text-sm font-medium text-gray-700">
              {currentCafeteria.city}, {currentCafeteria.state}
            </span>
          </div>
        </div>
      </div>

      {/* Componente de gerenciamento de horários */}
      <PlaceBusinessHoursMatrix placeId={currentCafeteria.id} />
    </div>
  );
};

export default BusinessHoursPage;
